"use client";

import { Client } from "@/lib/data";
import ClientCarousel from "./ClientCarousel";

interface ClientCarouselProps {
  title?: string;
  clients?: Client[];
  iconWidth?: number;
}
export default function ClientCarouselClient(props: ClientCarouselProps) {
  return <ClientCarousel {...props} />;
}
